export const mallFeedActionType = {
    MALLFEED_CONSTANTS:'MALLFEED_CONSTANTS',
    MALLFEED_SET_PAGE: 'MALLFEED_SET_PAGE',
    MALLFEED_SET_INIT: 'MALLFEED_SET_INIT',
};